import { useState } from "react";
import type { Preset } from "../types";
import { IconPlus, IconStar, IconTrash } from "./icons";
import { cx } from "./ui";

export function PresetBar({
  presets,
  onApply,
  onSave,
  onTogglePin,
  onDelete,
}: {
  presets: Preset[];
  onApply: (p: Preset) => void;
  onSave: (name: string) => void;
  onTogglePin: (p: Preset) => void;
  onDelete: (p: Preset) => void;
}) {
  const [naming, setNaming] = useState(false);
  const [name, setName] = useState("");

  const save = () => {
    const n = name.trim();
    if (!n) return;
    onSave(n);
    setName("");
    setNaming(false);
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5 border-b border-slate-100 px-5 py-3">
      <span className="mr-0.5 text-[12.5px] font-bold text-slate-400">プリセット</span>
      {presets.map((p) => (
        <span key={p.id} className="group relative inline-flex">
          <button
            type="button"
            onClick={() => onApply(p)}
            title={p.note || "クリックで設定を読み込む"}
            className={cx("chip pr-6", p.pinned && "border-amber-300 bg-amber-50 text-amber-700")}
          >
            {p.pinned && <IconStar className="h-3 w-3" filled />}
            {p.name}
          </button>
          <span className="absolute right-1 top-1/2 hidden -translate-y-1/2 gap-0.5 group-hover:flex">
            <button
              type="button"
              onClick={() => onTogglePin(p)}
              title="ピン留め"
              className="grid h-4 w-4 place-items-center rounded text-slate-400 hover:bg-white hover:text-amber-500"
            >
              <IconStar className="h-3 w-3" filled={p.pinned} />
            </button>
            <button
              type="button"
              onClick={() => onDelete(p)}
              title="削除"
              className="grid h-4 w-4 place-items-center rounded text-slate-400 hover:bg-white hover:text-rose-500"
            >
              <IconTrash className="h-3 w-3" />
            </button>
          </span>
        </span>
      ))}

      {naming ? (
        <span className="inline-flex items-center gap-1">
          <input
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") save();
              if (e.key === "Escape") setNaming(false);
            }}
            placeholder="プリセット名"
            className="w-40 rounded-lg border border-brand-300 px-2.5 py-1.5 text-[13px] outline-none focus:ring-2 focus:ring-brand-100"
          />
          <button type="button" onClick={save} className="chip border-brand-400 bg-brand-50 text-brand-700">
            保存
          </button>
        </span>
      ) : (
        <button type="button" onClick={() => setNaming(true)} className="chip border-dashed">
          <IconPlus className="h-3 w-3" />
          いまの設定を保存
        </button>
      )}
    </div>
  );
}
